import { USER_STATUS, USER_STATUS_JA, LANGUAGE } from '../../constants';
import type { ValueFormatterParams } from 'ag-grid-community';
import type { Language, SelectOption } from '../../types/common';

/**
 * userStatusの値を表示用にフォーマット
 * @param ValueFormatterParams （params.valueはnull/'0'/'1'/'2'/'3'）
 * @returns 0: 未連絡 1: 初回連絡済 2: ２回連絡済 3: 削除済"
 */
const userStatusFormatter = (params: ValueFormatterParams) => {
  const value = params.value;
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const formattedValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? USER_STATUS_JA[value] : USER_STATUS[value]) : value;
  return formattedValue;
};

export default userStatusFormatter;
